const defaultState = {
    assessment: {},
};

const mutations = {
    setLegionellaRiskAssessmentState(state, assessment) {
        state.assessment = assessment;
    },
    resetLegionellaRiskAssessmentState(state) {
        state.assessment = {};
    },
};

const actions = {
    async getLegionellaRiskAssessment({ commit, dispatch }, assessmentId) {
        try {
            const { data } = await this.$rq.getLegionellaRiskAssessment(assessmentId);
            commit('setLegionellaRiskAssessmentState', data);
        } catch (err) {
            dispatch('resetLegionellaRiskAssessment');
        }
    },
    resetLegionellaRiskAssessment({ commit }) {
        commit('resetLegionellaRiskAssessmentState');
    },
};

const getters = {
    assessment: state => state.assessment,
};

const state = { ...defaultState };

export default {
    state,
    getters,
    actions,
    mutations,
};
